/* SOLVEX pause/play control for anything that moves on its own (WCAG 2.2.2).
 *
 * A button carries data-solvex-motion-toggle and aria-controls pointing at the
 * moving element. Videos inside that element are paused or played directly;
 * any other element receives a `solvex:motion` event and decides for itself
 * (the category marquee listens for it).
 *
 * Starts paused when the device asks for reduced motion, or when the
 * accessibility menu's "Stop animations" is on (html.sx-a11y-stop-motion).
 * The menu announces changes with a `solvex:stop-motion` event on document.
 */
(function () {
  if (window.SolvexMotionToggle) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function motionStopped() {
    return reducedMotion.matches || document.documentElement.classList.contains('sx-a11y-stop-motion');
  }

  function setPaused(button, paused) {
    var target = document.getElementById(button.getAttribute('aria-controls'));
    if (!target) return;

    button.classList.toggle('is-paused', paused);
    button.setAttribute('aria-label', paused ? button.dataset.labelPlay : button.dataset.labelPause);

    target.querySelectorAll('video').forEach(function (video) {
      if (paused) {
        video.pause();
      } else {
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    });

    target.dispatchEvent(new CustomEvent('solvex:motion', { detail: { paused: paused } }));
  }

  function init(root) {
    (root || document).querySelectorAll('[data-solvex-motion-toggle]').forEach(function (button) {
      if (button.dataset.solvexMotionBound) return;
      button.dataset.solvexMotionBound = 'true';
      button.addEventListener('click', function () {
        setPaused(button, !button.classList.contains('is-paused'));
      });
      if (motionStopped()) setPaused(button, true);
    });
  }

  function applyGlobal() {
    var stopped = motionStopped();
    document.querySelectorAll('[data-solvex-motion-toggle]').forEach(function (button) {
      setPaused(button, stopped);
    });
  }

  window.SolvexMotionToggle = { init: init, applyGlobal: applyGlobal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('solvex:stop-motion', applyGlobal);
  if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', applyGlobal);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
